import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { normalizeExperience } from '../utils/normalizeExperience';
import AccessDeviceIcons from './AccessDeviceIcons';
import ExperienceRating from './ExperienceRating';

const Card = styled(motion.div)`
  flex: 0 0 140px;
  width: 140px;
  border: none;
  padding: 0;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  background: rgba(30, 20, 50, 0.8);
  text-align: left;
  color: #fff;

  &:hover {
    transform: translateY(-2px);
  }
`;

const Thumb = styled.div`
  height: 88px;
  background: url(${(p) => p.$src}) center/cover;
  background-color: rgba(255, 255, 255, 0.08);
`;

const Meta = styled.div`
  padding: 8px 10px 10px;
`;

const CardTitle = styled.div`
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const DeviceLine = styled(AccessDeviceIcons)`
  margin-top: 6px;
`;

const CardBadge = styled.div`
  font-size: 0.65rem;
  color: rgba(255, 255, 255, 0.65);
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

function ExperienceMiniCard({ experience, onClick }) {
  const normalized = normalizeExperience(experience);
  const image = normalized?.heroImageUrl || experience?.thumbnail;
  const badge = normalized?.formatBadge || experience?.categoryChip || '';

  return (
    <Card
      whileTap={{ scale: 0.98 }}
      onClick={() => onClick?.(experience)}
      aria-label={experience.title}
    >
      <Thumb $src={image} />
      <Meta>
        <CardTitle>{experience.title}</CardTitle>
        {badge && <CardBadge>{badge}</CardBadge>}
        <ExperienceRating experienceId={experience.id} compact />
        <DeviceLine experience={experience} compact />
      </Meta>
    </Card>
  );
}

export default ExperienceMiniCard;
